import BlueskyIcon from "@/components/icons/bluesky-icon"
import FacebookIcon from "@/components/icons/facebook-icon"
import GithubIcon from "@/components/icons/github-icon"
import InstagramIcon from "@/components/icons/instagram-icon"
import LinkedinIcon from "@/components/icons/linkedin-icon"
import MastodonIcon from "@/components/icons/mastodon-icon"
import PinterestIcon from "@/components/icons/pinterest-icon"
import ThreadsIcon from "@/components/icons/threads-icon"
import TwitterIcon from "@/components/icons/twitter-icon"
import YoutubeIcon from "@/components/icons/youtube-icon"

export default function PlatformIcon({
  platform,
  className,
}: {
  platform: string
  className?: string
}) {
  if (platform === "twitter") return <TwitterIcon className={className} />
  if (platform === "bluesky") return <BlueskyIcon className={className} />
  if (platform === "threads") return <ThreadsIcon className={className} />
  if (platform === "instagram") return <InstagramIcon className={className} />
  if (platform === "pinterest") return <PinterestIcon className={className} />
  if (platform === "facebook") return <FacebookIcon className={className} />
  if (platform === "mastodon") return <MastodonIcon className={className} />
  if (platform === "linkedin") return <LinkedinIcon className={className} />
  if (platform === "github") return <GithubIcon className={className} />
  if (platform === "youtube") return <YoutubeIcon className={className} />
  return null
}
